export class ConfigurationGeneration {
    id: number = 0;
    startsWith: string = '';
    length: number | null;
    formatType: FormatType | null = null;
    propertyType: ConfigurationGenerationPropertyType | null = null;

    static fromData(dataIn: any): ConfigurationGeneration {
        const item = new ConfigurationGeneration();
        item.id = dataIn.id ?? 0;
        item.startsWith = dataIn.startsWith ?? '';
        item.length = dataIn.length ?? null;
        item.formatType = (() => {
            switch (dataIn.formatType) {
                case 'Numeric': return FormatType.Numeric;
                case 'Alphanumeric': return FormatType.Alphanumeric;
                case 'AlphanumericWithSigns': return FormatType.AlphanumericWithSigns;
                default: return null;
            }
        })();
        item.propertyType = dataIn.propertyType === 'AccountNumber' 
            ? ConfigurationGenerationPropertyType.AccountNumber 
            : ConfigurationGenerationPropertyType.Spn;
        return item;
    }
}

export enum ConfigurationGenerationPropertyType {
    AccountNumber = 1,
    Spn = 2
}

export enum FormatType {
    Numeric = 1,
    Alphanumeric = 2,
    AlphanumericWithSigns = 3
}